<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="CtCreateHolidayDate"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("holidayDateCreate") }} </h6>
                      <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    >
                    
                    </div>
                 

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="date" class="col-form-label" style="padding-left: 25px">{{ $t("holidayDate") }} <span style="color: red;">*</span> </label>
                      </div>
                      <div class="col-lg-8">
                        
                        <Datepicker v-model="forms.date" :bootstrap-styling=true format="yyyy-MM-dd" :inline="false" :required="true"></Datepicker>

                        <div v-if="errors.date">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.date[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="remark" class="col-form-label" style="padding-left: 25px">{{ $t("remarks_txt") }} </label>
                      </div>
                      <div class="col-lg-8">
                        <input type="text" class="form-control" :id="$dynamicId()" :placeholder="$t('remarks_txt')"
                          v-model="forms.remark" :class="{ 'is-invalid': errors.remark }" />
                        <div v-if="errors.remark">
                          <div class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i> {{ errors.remark[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                     <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "CtCreateHolidayDate",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    Datepicker,
  },
  data() {
    return {
      pickupDates: {
      startDate: null,
      endDate: null,
      },
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchRole:[],
      fetchPermission:[],
      userData: "",
      companyCode: "",
      permission:[],
      role:[],
        forms:{holiday_id:'' , date:'' , remark:'' , create_by:'',  update_by:'',  created_at:'',  updated_at:''},
    };
  },
  watch: {},
    methods: {

        formatDate(val) {
          return val ? moment(val).format("YYYY-MM-DD") : "";
        },

        resetForm() {
            this.forms = {holiday_id:'' , date:'' , remark:'' , create_by:'',  update_by:'',  created_at:'',  updated_at:''};
        },


        backForm() {
            window.location.href = "/holiday-date";
        },

        submitData() {
          this.fade(true);
 
          var formData = {
            date:moment(String(this.forms.date)).format('YYYY-MM-DD'),
            remark:this.forms.remark
          };
         
          const baseURI  =  this.$settings.endPointCt+"holiday/create";
          this.$http.post(baseURI,formData).then((response) => {
              this.loading();
              if(response.data.status === 200) {
              //this.resetForm();
                  this.errors = [];
                  //console.log(response.data.datas.user_id);
                  var params = this.$onRandom(response.data.datas.holiday_id);
                      window.location.href = "/holiday-date/detail/" + params + "?status=200&msg=Successfully";
                  // this.success('Berhasil');
              }else{
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
              }
          }).catch(error => {
              this.loading();
              if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      
                      this.error(this.errors.messages);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
              }
              //this.resetForm();
          });
        },

        fade(sType) {
        this.isLoading = sType;
        },


        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.detailUser     = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
                if(permision.permission.controller == 'HolidayController'){
                rolePermision = permision;
                }
            });

            if(!rolePermision.method_create){
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

        },

        loading() {
        this.fade(true);
        setTimeout(() => {
            this.fade(false);
        }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
            }
        }
        },

        success(kata) {
        const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
        });
        Toast.fire({
            icon: "success",
            title: kata,
        });
        },
 
        error(kata) {
        const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
        });
        Toast.fire({
            icon: "error",
            title: kata,
        });
        },

  },
  events: {},
  created: function () {},
  mounted() {
      this.fetchIt();
  },
};
</script>
<style scoped>
</style>